import { APIHelpSection } from '@partnerconnect-monorepo/types/HelpSection';
import { HelpSectionEditFormView } from './HelpSectionEditFormView';
import { useHelpSectionEditForm } from './HelpSectionEditForm.hooks';

interface HelpSectionEditFormProps {
  helpSection: APIHelpSection;
  closeForm: () => void;
}

export const HelpSectionEditForm = ({
  helpSection,
  closeForm
}: HelpSectionEditFormProps) => {
  const { control, onCancel, onSubmit, isLoading } = useHelpSectionEditForm(
    helpSection,
    closeForm
  );

  return (
    <HelpSectionEditFormView
      control={control}
      onCancel={onCancel}
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  );
};
